/**
 * Where a signed-out visitor was headed, restored once they are signed in and
 * their org has loaded.
 */
export const POST_LOGIN_PATH_KEY = 'pratus.postLoginPath';

const IGNORED_PATHS = ['/', '/logout', '/invite'];

/**
 * Remembers a deep link (path, query and hash) before auth redirects back to
 * the site root.
 */
export function rememberPostLoginPath(
  location: Pick<Location, 'pathname' | 'search' | 'hash'>
): void {
  if (IGNORED_PATHS.includes(location.pathname)) return;
  if (sessionStorage.getItem(POST_LOGIN_PATH_KEY)) return;
  sessionStorage.setItem(
    POST_LOGIN_PATH_KEY,
    `${location.pathname}${location.search}${location.hash}`
  );
}

export function peekPostLoginPath(): string | null {
  const path = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
  return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
}

export function clearPostLoginPath(): void {
  sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
}
